import React from "react";
import { Link } from "react-router-dom";
import { Fuel, MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
    return (
        <footer className="bg-slate-900 text-slate-300 mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div>
                    <div className="flex items-center gap-2 mb-4">
                        <div className="w-9 h-9 bg-blue-700 flex items-center justify-center rounded-sm">
                            <Fuel className="w-5 h-5 text-yellow-400" />
                        </div>
                        <div>
                            <div className="font-heading font-black text-white text-lg tracking-tight">VAISHALI FUELS</div>
                            <div className="text-[10px] font-mono-plex text-slate-500 uppercase tracking-widest">Bharat Petroleum Dealer</div>
                        </div>
                    </div>
                    <p className="text-sm text-slate-400 leading-relaxed">
                        Authorised Bharat Petroleum (BPCL) dealer for door-to-door diesel delivery. On-time, metered, high-quality diesel delivered directly to your factory, farm, generator or site across Vadodara & Central Gujarat.
                    </p>
                </div>
                <div>
                    <h4 className="font-heading font-bold text-white text-sm uppercase tracking-widest mb-4">Company</h4>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/about" className="hover:text-yellow-400">About Us</Link></li>
                        <li><Link to="/coverage" className="hover:text-yellow-400">Service Coverage</Link></li>
                        <li><Link to="/contact" className="hover:text-yellow-400">Contact</Link></li>
                        <li><Link to="/order" className="hover:text-yellow-400">Place Order</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-heading font-bold text-white text-sm uppercase tracking-widest mb-4">Contact</h4>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-yellow-400 shrink-0" /> D-49 Pratap Baug Society, Above Vaishali Travels, Nr. Shivaji Circle, Munjmahuda, Akota, Vadodara — 390020</li>
                        <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-yellow-400" /> +91 95124 77777</li>
                        <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-yellow-400" /> vaishalifuels20@gmail.com</li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-heading font-bold text-white text-sm uppercase tracking-widest mb-4">Compliance</h4>
                    <ul className="space-y-2 text-xs text-slate-400 leading-relaxed">
                        <li>Authorised BPCL dealer &amp; bowser operator</li>
                        <li>Calibrated flow meters (W&amp;M certified)</li>
                        <li>PESO-compliant logistics</li>
                        <li>VAT No.&nbsp;24190206382</li>
                        <li>Tax-compliant invoicing on delivery</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-slate-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
                    <div>© {new Date().getFullYear()} Vaishali Fuels. All rights reserved.</div>
                    <div className="font-mono-plex">VAISHALI FUELS · VADODARA · GUJARAT</div>
                </div>
            </div>
        </footer>
    );
}
